module.exports = __webpack_public_path__ + "static/img/soldoc_logo.4b2a4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/soldoc_logo.png
// module id = Zbr0
// module chunks = 1